import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const Anchor = styled('div', {
  base: {
    position: 'fixed',
    bottom: '24px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: '95',
    pointerEvents: 'none',
  },
})

const ToastCard = styled(motion.div, {
  base: {
    pointerEvents: 'auto',
    backgroundColor: 'quickpass.ink',
    color: '#FFFFFF',
    paddingX: '20px',
    paddingY: '12px',
    borderRadius: 'pill',
    boxShadow: '0 24px 48px -16px rgba(26, 19, 48, 0.45)',
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
  },
})

const Message = styled('span', {
  base: {
    color: '#FFFFFF',
  },
})

const UndoButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '700',
    color: 'quickpass.celebration',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '0',
    transition: 'color {durations.fast} {easings.appleStandard}',
    _hover: { color: '#FFFFFF' },
  },
})

const DismissButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '0',
    transition: 'color {durations.fast} {easings.appleStandard}',
    _hover: { color: '#FFFFFF' },
  },
})

export { Anchor, ToastCard, Message, UndoButton, DismissButton }
